import React from 'react';
import PropTypes from 'prop-types';

const Agreement = ({ text, hasAgreed, onAgreement }) => {
  return (
    <div style={{ marginBottom: '1em' }}>
      <label className='checkbox-label pointer-hover'>
        <input id='agree-checkbox' className='pointer-hover' type='checkbox' value={hasAgreed} onClick={onAgreement} />
        <span>{text}</span>
      </label>
    </div>
  );
};

Agreement.propTypes = {
  text: PropTypes.string,
  hasAgreed: PropTypes.bool,
  onAgreement: PropTypes.func,
};

export default Agreement;
